"use client";
import { Box, Button, Stack, styled, Typography } from "@mui/material";
import Image from "next/image";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { TitleGradientText } from "../title_gradient_text";
import { mockReview, ReviewType } from "@/data/review_mock_data";
import { useRouter } from "next/navigation";

const GridContainer = styled(Box)`
  display: grid;
  grid-auto-flow: column; /* Lay out items in columns, not rows */
  grid-auto-columns: 320px; /* Define the width of each column */
  grid-template-rows: repeat(2, 192px);
  width: 100%;
  overflow-x: scroll;
  scrollbar-width: none;
`;

export function ReviewSection() {
  const router = useRouter();

  const handleReviewsClick = () => {
    router.push("/reviews");
  };
  return (
    <Stack
      width="100%"
      justifyContent="center"
      alignItems="center"
      py={{
        xs: 15,
        md: 25,
      }}
      gap={{
        xs: 12,
        md: 15,
      }}
    >
      <Stack gap={2}>
        <TitleGradientText variant="h3" textAlign="center">
          รีวิวจากลูกค้า
        </TitleGradientText>
        <TitleGradientText variant="body1" textAlign="center">
                  การันตีความอร่อย จากผู้ใช้จริง
                </TitleGradientText>
      </Stack>
      <GridContainer gap={5}>
        {mockReview.map((item, index) => {
          let height: string | number = 0;
          let span = 1;
          switch ((index + 1) % 5) {
            case 1:
            case 2:
              height = 192;
              span = 1;
              break;
            default:
              height = "100%";
              span = 2;
              break;
          }

          if (item.reviewType === ReviewType.VIDEO) {
            return (
              <Stack
                key={index}
                height={height}
                width="100%"
                borderRadius={4}
                sx={{
                  overflow: "hidden",
                  gridRow: `span ${span}`,
                  boxShadow:
                    "0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.1)",
                }}
                justifyContent="space-between"
                position="relative"
              >
                <video
                  playsInline={true}
                  controls={true}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                >
                  <source src={item.review} type="video/mp4" />
                </video>
              </Stack>
            );
          } else if (item.reviewType === ReviewType.TEXT) {
            return (
              <Stack
                key={index}
                height={height}
                width="100%"
                p={6}
                borderRadius={4}
                sx={{
                  gridRow: `span ${span}`,
                  boxShadow:
                    "0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.1)",
                  backgroundImage:
                    "linear-gradient(180deg,rgba(7, 12, 15, 1) 51%, rgba(110, 24, 18, 1) 93%);",
                }}
                justifyContent="space-between"
                position="relative"
              >
                <Box
                  width="100%"
                  height="100%"
                  position="absolute"
                  top={0}
                  left={0}
                  zIndex={0}
                  sx={{
                    backgroundColor: "rgba(7, 12, 15, 0.5)",
                  }}
                />
                <Stack gap={4} zIndex={1}>
                  <Stack direction="row" gap={1}>
                    <Image src="svg/star.svg" width={14} height={14} alt="" />
                    <Image src="svg/star.svg" width={14} height={14} alt="" />
                    <Image src="svg/star.svg" width={14} height={14} alt="" />
                    <Image src="svg/star.svg" width={14} height={14} alt="" />
                    <Image src="svg/star.svg" width={14} height={14} alt="" />
                  </Stack>
                  <Typography variant="body2" fontWeight={300}>
                    {item.review}
                  </Typography>
                </Stack>

                <Stack direction="row" gap={3} zIndex={1} alignItems="center">
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img
                    src={item.authorImage ? item.authorImage : ""}
                    width={36}
                    height={36}
                    alt=""
                    style={{
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                  <Typography
                    variant="subtitle2"
                    fontWeight={300}
                    color="textSecondary"
                  >
                    {item.author}
                  </Typography>
                </Stack>
              </Stack>
            );
          }
        })}
      </GridContainer>

      <Stack>
        <Button variant="contained" onClick={handleReviewsClick}>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="button" color="textPrimary">
              ชมรีวิวทั้งหมด
            </Typography>
            <ArrowForwardRoundedIcon
              style={{
                color: "#fff",
              }}
            />
          </Stack>
        </Button>
      </Stack>
    </Stack>
  );
}
